module.exports = Jsw.skinUrl + "/icons/16/plesk/file-arch.png?672559f884c624090a3e3687f16148ec";